import { GraphQLProvider } from '@tbitop/api';
import { useGlobalGraphQLErrorHandler } from '@tbitop/error-handling';
import type { PropsWithChildren } from 'react';

type OneplatformApiProviderProps = {
  apiUrl: string;
};

const emptyTypePolicies = {
  Rolle: {
    keyFields: ['produkt', 'bezeichnung'],
  },
};

export const OneplatformApiProvider = ({ apiUrl, children }: PropsWithChildren<OneplatformApiProviderProps>) => (
  <GraphQLProvider
    id="oneplatform"
    uri={apiUrl}
    typePolicies={emptyTypePolicies}
    errorHandler={useGlobalGraphQLErrorHandler()}
  >
    {children}
  </GraphQLProvider>
);
